/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbRespTradeFreeShippingPromoTile_viewer$ref = any;
export type SbRespTradeFreeShippingPromoTile_viewer = {
    readonly shippingFilters?: ReadonlyArray<{
        readonly name: string | null;
        readonly values: ReadonlyArray<{
            readonly urlLabel: string | null;
            readonly displayName: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $refType": SbRespTradeFreeShippingPromoTile_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespTradeFreeShippingPromoTile_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "uriRef",
            "type": "String"
        },
        {
            "kind": "RootArgument",
            "name": "userZipCode",
            "type": "String"
        },
        {
            "kind": "RootArgument",
            "name": "isClient",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isClient",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "shippingFilters",
                    "storageKey": null,
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "uriRef",
                            "variableName": "uriRef"
                        },
                        {
                            "kind": "Variable",
                            "name": "zipCode",
                            "variableName": "userZipCode"
                        }
                    ],
                    "concreteType": "ShippingFilterType",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "name",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "values",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "FilterValueType",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "urlLabel",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "displayName",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = '236c52217634abee58a5c97bcbbdc5c0';
export default node;
